// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/builds/msfund/msvc-web/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelComment0 from '/builds/msfund/msvc-web/src/models/comment.ts';
import ModelDictionary1 from '/builds/msfund/msvc-web/src/models/dictionary.ts';
import ModelGlobal2 from '/builds/msfund/msvc-web/src/models/global.ts';
import ModelLeads3 from '/builds/msfund/msvc-web/src/models/leads.ts';
import ModelLogin4 from '/builds/msfund/msvc-web/src/models/login.ts';
import ModelProject5 from '/builds/msfund/msvc-web/src/models/project.ts';
import ModelSetting6 from '/builds/msfund/msvc-web/src/models/setting.ts';
import ModelTeam7 from '/builds/msfund/msvc-web/src/models/team.ts';
import ModelUser8 from '/builds/msfund/msvc-web/src/models/user.ts';
import ModelIndex9 from '/builds/msfund/msvc-web/src/pages/Deal/models/index.ts';
import ModelIndex10 from '/builds/msfund/msvc-web/src/pages/Home/Kanban/models/index.ts';
import ModelMySpace11 from '/builds/msfund/msvc-web/src/pages/Home/MySpace/models/mySpace.ts';
import ModelIndex12 from '/builds/msfund/msvc-web/src/pages/Home/TopicSquare/models/index.ts';
import ModelLogList13 from '/builds/msfund/msvc-web/src/pages/Leads/models/logList.ts';
import ModelIndex14 from '/builds/msfund/msvc-web/src/pages/Workbench/Log/models/index.ts';
import ModelWriteLog15 from '/builds/msfund/msvc-web/src/pages/Workbench/Log/models/writeLog.ts';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'comment', ...ModelComment0 });
app.model({ namespace: 'dictionary', ...ModelDictionary1 });
app.model({ namespace: 'global', ...ModelGlobal2 });
app.model({ namespace: 'leads', ...ModelLeads3 });
app.model({ namespace: 'login', ...ModelLogin4 });
app.model({ namespace: 'project', ...ModelProject5 });
app.model({ namespace: 'setting', ...ModelSetting6 });
app.model({ namespace: 'team', ...ModelTeam7 });
app.model({ namespace: 'user', ...ModelUser8 });
app.model({ namespace: 'index', ...ModelIndex9 });
app.model({ namespace: 'index', ...ModelIndex10 });
app.model({ namespace: 'mySpace', ...ModelMySpace11 });
app.model({ namespace: 'index', ...ModelIndex12 });
app.model({ namespace: 'logList', ...ModelLogList13 });
app.model({ namespace: 'index', ...ModelIndex14 });
app.model({ namespace: 'writeLog', ...ModelWriteLog15 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
